var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 30",
    style: {
      enableBackground: "new 0 0 30 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#0A1227;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -1696 -231 )"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1720.6,248.1c0.2-0.2,0.4-0.5,0.4-0.9v-2.5c0-0.3-0.1-0.6-0.4-0.9s-0.5-0.4-0.9-0.4h-6.3v-6.3 c0-0.3-0.1-0.6-0.4-0.9s-0.5-0.4-0.9-0.4h-2.5c-0.3,0-0.6,0.1-0.9,0.4s-0.4,0.5-0.4,0.9v6.3h-6.3c-0.3,0-0.6,0.1-0.9,0.4 s-0.4,0.5-0.4,0.9v2.5c0,0.3,0.1,0.6,0.4,0.9s0.5,0.4,0.9,0.4h6.3v6.3c0,0.3,0.1,0.6,0.4,0.9s0.5,0.4,0.9,0.4h2.5 c0.3,0,0.6-0.1,0.9-0.4s0.4-0.5,0.4-0.9v-6.3h6.3C1720.1,248.5,1720.4,248.4,1720.6,248.1z M1724.3,232.7c1.1,1.1,1.7,2.4,1.7,4 v18.8c0,1.5-0.6,2.9-1.7,4s-2.4,1.7-4,1.7h-18.8c-1.5,0-2.9-0.6-4-1.7s-1.7-2.4-1.7-4v-18.8c0-1.5,0.6-2.9,1.7-4s2.4-1.7,4-1.7 h18.8C1721.9,231,1723.2,231.6,1724.3,232.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.73ee943ffca509b6628a45e0d69ee86b.svg";
export { ForwardRef as ReactComponent };